import { renderApp } from './index';

/**
 * `MODE=iframe` entry.
 *
 * Studio serves its own `index.html` (which carries the `#root` element) and the
 * Bynder portal embeds that page in an iframe, handing over the access token on
 * a `MessageChannel`. The guard stops the app booting when the page is opened
 * directly at the top level, which is how a bare bundle URL gets probed.
 *
 * No config is passed: with no base path the router owns the document root, and
 * with no token endpoint `checkPlatformUsage` waits for the host's message
 * channel — which is exactly this deployment.
 */
if (window !== window.parent) {
    const root = document.querySelector('#root');

    if (root) {
        renderApp(root);
    }
}
